<template>
  <p class="font-semibold">Copy the code below to embed in your website</p>
  <FormKit type="toggle" name="showTitle" :value="showTitle" label="Show file title" data-testid="toggle-title" @input="embedStore.toggleShowTitle()" />
  <FormKit
    v-if="!free"
    type="toggle"
    name="showBranding"
    :value="showBranding"
    label="Show Zight branding"
    data-testid="toggle-branding"
    @input="embedStore.toggleShowBranding()"
  />
  <pre
    class="w-96 md:w-full p-4 text-sm bg-slate-50 dark:bg-zinc-700 rounded-10 border border-slate-300 dark:border-zinc-600 whitespace-nowrap overflow-x-auto"
  >
    {{ embedHtml }}
  </pre>
  <Button type="solid" variant="blue" icon="general.copyFileFolder" @click.prevent="copy()" data-testid="copy-embed-to-clipboard"
    >Copy code to clipboard</Button
  >
</template>

<script setup lang="ts">
import { Ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useClipboard } from '@vueuse/core';
import { Button } from '@/storybook/button';

import { useToast } from '@/composables/useToast';

import { useOrganizationStore } from '@/store/useOrganizationStore';
import { useEmbedStore } from '@/modules/viewer/store/useEmbedStore';

const { success } = useToast();
const embedStore = useEmbedStore();

const { embedHtml, showBranding, showTitle } = storeToRefs(embedStore);
const { free } = storeToRefs(useOrganizationStore());

const { copy, copied } = useClipboard({ source: embedHtml as Ref });

watch(copied, res => {
  if (!res) {
    return;
  }

  success('Embed code copied to clipboard', { icon: 'general.copy' });
});
</script>
